export default __webpack_public_path__ + "static/media/gallery_07.c8610d70.jpg";